/**
 * This is the configuration of the SDK. The server url of all REST endpoints and to the streaming server are set here.
 */
import {
  IAdmin,
  IAuth,
  IRest,
  IUser,
  IUserPortal,
  IStreaming,
  IReTrading,
  IBrokerageTrading,
  ILogger,
  IDoryConfig,
} from './interface/IDoryConfig';
import { Logger, LogSender } from './logger';

//#region init
let basePath = 'https://dory.financial.com/';
let baseDomain = 'dory.financial.com/';

const admin: IAdmin = {
  url: null,
};

const auth: IAuth = {
  url: null,
  urlSession: null,
  urlToken: null,
};

const userPortal: IUserPortal = {
  url: null,
};

const user: IUser = {
  url: null,
};

const rest: IRest = {
  url: null,
};

const streaming: IStreaming = {
  sock_url: null,
  ws_url: null,
};

const reTrading: IReTrading = {
  sock_url: null,
  ws_url: null,
};
const brokerageTrading: IBrokerageTrading = {
  sock_url: null,
  ws_url: null,
};

let _logLevel = -1;
const logger: ILogger = {
  get level(): number {
    return _logLevel;
  },
  set level(level: number) {
    _logLevel = level;
    Logger.debug(LogSender.CONFIG, `new logger level is ${level}`);
  },
};

enum LogLevel {
  DISABLED = -1,
  CRITICAL = 0,
  ERROR = 1,
  WARNING = 2,
  INFO = 3,
  VERBOSE = 4,
  SILLY = 5,
}
//#endregion

/**
 * This function sets all needed REST/Streaming path
 *
 * @param {string} newBasePath The base path like this: https://dory.financial.com
 * @returns void
 */
function setBasePath(newBasePath: string): void {
  newBasePath = newBasePath.trim();
  if (newBasePath.slice(-1) === '/') {
    newBasePath = newBasePath.slice(0, -1);
  }
  basePath = newBasePath;
  baseDomain = basePath.split('://')[1];

  admin.url = `${basePath}/auth/api/v1/administration`;

  auth.url = `${basePath}/auth/api/v1`;
  auth.urlSession = `${basePath}/auth/api/v1/sessions`;
  auth.urlToken = `${basePath}/auth/api/v1/tokens`;

  userPortal.url = `${basePath}/user-portal/api/v1/sessions`;

  user.url = `${basePath}/auth/api/v1/usersettings`;

  rest.url = `${basePath}/rest/api`;

  streaming.sock_url = `${basePath}/streaming/streams`;
  streaming.ws_url = `wss://${baseDomain}/streaming/ticks`;
}

/**
 * This function gets an full configuration object
 *
 * @param {IDoryConfig} newConfig The config object
 * @returns void
 */
function setConfigObject(newConfig: IDoryConfig): void {
  Object.assign(admin, newConfig.admin);
  Object.assign(auth, newConfig.auth);
  Object.assign(userPortal, newConfig.userPortal);
  Object.assign(user, newConfig.user);
  Object.assign(rest, newConfig.rest);
  Object.assign(streaming, newConfig.streaming);
  Object.assign(logger, newConfig.logger);
}

const config = {
  admin,
  auth,
  rest,
  user,
  userPortal,
  streaming,
  reTrading,
  brokerageTrading,
  logger,
  setBasePath,
  setConfigObject,
};

export default config;
export {
  admin,
  auth,
  rest,
  user,
  userPortal,
  streaming,
  reTrading,
  brokerageTrading,
  logger,
  setBasePath,
  setConfigObject,
  LogLevel,
};
